<template>
  <div>
    <header class="section-header section-header-informes mb-3">
      <h3 class="text-transparencia">
        INFORMES
      </h3>
      <hr style="border-top-color: rgba(0, 0, 0, 0.15) !important;" />
    </header>

    <div id="slider-informes">
      <template v-for="(informe, index) in informes">
        <div class="pl-2 pr-2" :key="index">
          <div class="card card-frame card-owework border hover-shadow-9 transition-hover">
            <div class="card-img-top w-100 text-center">
              <a :href="'/informes/detalle/' + informe.informeId">
                <img 
                  v-if="informe.rutaImagenMiniatura" 
                  class="img-fluid w-100 rounded cimage-slider" 
                  :src="`${filesUrl}${informe.rutaImagenMiniatura}`" 
                  :alt="informe.titulo" 
                />
                <div v-else class="img-fluid w-100 rounded cimage-slider d-flex align-items-center justify-content-center bg-light">
                  <i class="fa fa-file-alt fa-4x text-muted"></i>
                </div>
              </a>
            </div>
            <div class="card-body p-2">
              <div class="d-flex justify-content-center text-center" style="height:6.6rem !important;overflow:hidden">
                <a :href="'/informes/detalle/' + informe.informeId">
                  <h6 class="card-title fs-15 text-transparencia">{{ informe.titulo }}</h6>
                </a>
              </div>
            </div>
            <div class="card-footer text-right pt-0">
              <a class="fs-13 fw-600 anim-link-2 anim-link-2-primary" :href="'/informes/detalle/' + informe.informeId">
                Ver más<i class="fa fa-search-plus ml-1"></i>
              </a>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="col-md-12 text-center mt-4">
      <router-link to="/informes" class="btn btn-primary">Ver todo</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "view-informes-voluntariado",
  components: {},
  data: () => ({
    informes: [],
  }),
  methods: {
    fetchInformes: function() {
      var self = this;
      this.$http.get(this.apiRoute("Informe", "GetInformes")).then(function(response) {
        if (!response.body.error) {
          self.informes = response.body.data;
        }
        // Esperar a que Vue renderice
        self.$nextTick(function() {
          // Aplicar flex temporalmente para evitar apilamiento
          var sliderElement = $("#slider-informes");
          if (sliderElement.length > 0) {
            sliderElement.css({
              'display': 'flex',
              'overflow-x': 'hidden'
            });
            sliderElement.find('.pl-2').css({
              'flex-shrink': '0',
              'width': '25%'
            });
            
            // Esperar suficiente tiempo para que el DOM esté completamente listo
            // startSlider tiene su propio setTimeout de 300ms, así que esperamos un poco más
            setTimeout(function() {
              // Remover los estilos inline que pueden interferir con Slick
              sliderElement.removeAttr('style');
              sliderElement.find('.pl-2').removeAttr('style');
              
              // Verificar que hay elementos antes de inicializar
              if (sliderElement.find('.card').length > 0) {
                // Destruir slider previo si existe
                if (sliderElement.hasClass('slick-initialized')) {
                  sliderElement.slick('unslick');
                }
                
                // Llamar a startSlider que tiene su propio setTimeout interno de 300ms
                startSlider("slider-informes", [4, 3, 3, 2, 2, 1]);
              }
            }, 250);
          }
        });
      });
    },
  },
  mounted: function() {
    this.fetchInformes();
  },
};
</script>

<style scoped>
.section-header-informes {
  text-align: center;
}

.section-header-informes h3 {
  font-size: 2rem;
  font-weight: 800;
  margin-bottom: 0.5rem;
}

.section-header-informes hr {
  width: 60px;
  margin: 0 auto;
  border-top: 3px solid #2484da;
}

.btn-transparencia {
  background-color: #2484da !important;
  border-color: #2484da !important;
  color: white !important;
}

.btn-transparencia:hover {
  background-color: #1e6bb8 !important;
  border-color: #1e6bb8 !important;
}

/* Estilos para el carrusel */
.slick-prev:before,
.slick-next:before {
  color: #2484da !important;
}

.slick-prev {
  left: -25px;
}

.slick-next {
  right: -25px;
}

/* NO usar display: flex !important aquí - se maneja con JavaScript */
/* Esto evita conflictos con Slick después de su inicialización */

/* Responsive */
@media (max-width: 768px) {
  .slick-prev,
  .slick-next {
    display: none !important;
  }
}
</style>
